// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__7O7si","title":"style_title__4f8Ty","content":"style_content__1XZe9"};